import * as types from '@/store/mutation-types';
import { searchParty } from '@/mixins/search-party';

const mutations = {
  [types.ADD_NEW_EVENT_CARD](state, p) {
    const drp = p.drp;
    drp.cards.splice(0, 0, p.newCard);
  },
  [types.REMOVE_EVENT_CARD](state, p) {
    const drp = p.drp;
    const mq = searchParty.methods._goFind({
      entry: drp.mediaQueries,
      key: 'selector',
      value: `#drp-${p.cardId}`,
    });
    mq.parentArray.splice(mq.index, 1);
    drp.cards.splice(p.cardIndex, 1);
  },
  [types.SET_EVENT_CARD_TEXT](state, p) {
    const drp = p.drp;
    drp.cards[p.cardIndex][p.type] = p[p.type];
  },
};

const actions = {
  addNewEventCard: ({ commit }, payload) => {
    commit(types.ADD_NEW_EVENT_CARD, payload);
  },
  removeEventCard: ({ commit }, payload) => {
    commit(types.REMOVE_EVENT_CARD, payload);
  },
  async setEventCardText({ dispatch, commit }, payload) {
    payload[payload.type] = payload[payload.type];
    await commit(types.SET_EVENT_CARD_TEXT, payload);
    dispatch('setSiteSave', { status: true, type: 'Droplet' });
  },
};

export default {
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/cards-event/vuex.js